export default function CStdlibH() {
  return <h2>C Stdlib H</h2>;
}
